import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute    from './components/ProtectedRoute';
import MonodepinLogo    from './components/MonodepinLogo';
import LoginPage         from './pages/LoginPage';
import SiniestrosList    from './pages/SiniestrosList';
import SiniestroDetalle  from './pages/SiniestroDetalle';
import PeritosList       from './pages/PeritosList';
import PeritoDetalle     from './pages/PeritoDetalle';
import ClientesList      from './pages/ClientesList';
import ClienteDetalle    from './pages/ClienteDetalle';
import FacturasList         from './pages/FacturasList';
import FacturaDetalle       from './pages/FacturaDetalle';
import FacturaPdfPage       from './pages/FacturaPdfPage';
import InformeSiniestrosPage   from './pages/InformeSiniestrosPage';
import SiniestroPartePdfPage   from './pages/SiniestroPartePdfPage';
import AdminPage               from './pages/AdminPage';
import './index.css';

const NAV_ITEMS = [
  { key: 'siniestros', label: 'Siniestros', icon: '🏠' },
  { key: 'facturas',   label: 'Facturas',   icon: '🧾' },
  { key: 'informes',   label: 'Informes',   icon: '📊' },
  { key: 'clientes',   label: 'Clientes',   icon: '👥' },
  { key: 'peritos',    label: 'Peritos',     icon: '👷' },
];

function TopNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const seccion = location.pathname.split('/')[1];

  return (
    <nav className="hidden sm:flex bg-primary-700 text-white px-6 py-0 shadow-md items-center gap-1">
      <div className="mr-6 py-2.5 cursor-pointer" onClick={() => navigate('/siniestros')}>
        <MonodepinLogo />
      </div>
      {NAV_ITEMS.map(item => (
        <button
          key={item.key}
          onClick={() => navigate(`/${item.key}`)}
          className={`px-4 py-3 text-sm font-medium transition border-b-2
            ${seccion === item.key
              ? 'border-white text-white'
              : 'border-transparent text-primary-200 hover:text-white hover:border-primary-300'
            }`}
        >
          {item.icon} {item.label}
        </button>
      ))}
      <div className="ml-auto flex items-center gap-3 py-2">
        <span className="text-sm text-primary-200">{user?.nombre}</span>
        <button
          onClick={() => navigate('/admin')}
          title="Administración"
          aria-label="Administración"
          className="p-1.5 text-primary-300 hover:text-white hover:bg-primary-600 rounded-lg transition"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
        </button>
        <button
          onClick={logout}
          title="Cerrar sesión"
          aria-label="Cerrar sesión"
          className="p-1.5 text-primary-300 hover:text-white hover:bg-primary-600 rounded-lg transition"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
        </button>
      </div>
    </nav>
  );
}

function MobileHeader() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <header className="sm:hidden flex items-center justify-between bg-primary-700 text-white px-4 py-2 shadow-md">
      <div className="cursor-pointer" onClick={() => navigate('/siniestros')}>
        <MonodepinLogo />
      </div>
      <div className="flex items-center gap-1">
        <span className="text-xs text-primary-200 mr-1">{user?.nombre}</span>
        <button
          onClick={() => navigate('/admin')}
          title="Administración"
          className="p-2 text-primary-300 hover:text-white hover:bg-primary-600 rounded-lg transition"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
          </svg>
        </button>
        <button
          onClick={logout}
          title="Cerrar sesión"
          className="p-2 text-primary-300 hover:text-white hover:bg-primary-600 rounded-lg transition"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
        </button>
      </div>
    </header>
  );
}

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const seccion = location.pathname.split('/')[1];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 sm:hidden pb-safe">
      <div className="flex">
        {NAV_ITEMS.map(item => (
          <button
            key={item.key}
            onClick={() => navigate(`/${item.key}`)}
            className={`flex-1 flex flex-col items-center py-2 text-xs transition
              ${seccion === item.key
                ? 'text-primary-600 font-semibold'
                : 'text-gray-500 hover:text-gray-700'
              }`}
          >
            <span className="text-xl">{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}

function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <TopNav />
      <MobileHeader />
      <div className="pb-20 sm:pb-0">{children}</div>
      <BottomNav />
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Navigate to="/siniestros" replace />} />
      <Route path="/siniestros" element={
        <ProtectedRoute><Layout><SiniestrosList /></Layout></ProtectedRoute>
      } />
      <Route path="/siniestros/:id" element={
        <ProtectedRoute><Layout><SiniestroDetalle /></Layout></ProtectedRoute>
      } />
      <Route path="/peritos" element={
        <ProtectedRoute><Layout><PeritosList /></Layout></ProtectedRoute>
      } />
      <Route path="/peritos/:id" element={
        <ProtectedRoute><Layout><PeritoDetalle /></Layout></ProtectedRoute>
      } />
      <Route path="/clientes" element={
        <ProtectedRoute><Layout><ClientesList /></Layout></ProtectedRoute>
      } />
      <Route path="/clientes/:id" element={
        <ProtectedRoute><Layout><ClienteDetalle /></Layout></ProtectedRoute>
      } />
      <Route path="/facturas" element={
        <ProtectedRoute><Layout><FacturasList /></Layout></ProtectedRoute>
      } />
      <Route path="/facturas/:id" element={
        <ProtectedRoute><Layout><FacturaDetalle /></Layout></ProtectedRoute>
      } />
      <Route path="/facturas/:id/pdf" element={
        <ProtectedRoute><FacturaPdfPage /></ProtectedRoute>
      } />
      <Route path="/siniestros/:id/parte-pdf" element={
        <ProtectedRoute><SiniestroPartePdfPage /></ProtectedRoute>
      } />
      <Route path="/informes/siniestros" element={
        <ProtectedRoute><Layout><InformeSiniestrosPage /></Layout></ProtectedRoute>
      } />
      <Route path="/informes" element={
        <Navigate to="/informes/siniestros" replace />
      } />
      <Route path="/admin" element={
        <ProtectedRoute><Layout><AdminPage /></Layout></ProtectedRoute>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
